/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapporten_Config_Elements_Zwemvaardigheid_AchterkantInputs */

const nl_rapporten_config_elements_zwemvaardigheid_achterkant = /** @type {(inputs: Rapporten_Config_Elements_Zwemvaardigheid_AchterkantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwemvaardigheid`)
};

/**

* @param {Rapporten_Config_Elements_Zwemvaardigheid_AchterkantInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const rapporten_config_elements_zwemvaardigheid_achterkant = /** @type {((inputs?: Rapporten_Config_Elements_Zwemvaardigheid_AchterkantInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapporten_Config_Elements_Zwemvaardigheid_AchterkantInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_rapporten_config_elements_zwemvaardigheid_achterkant(inputs)
});
export { rapporten_config_elements_zwemvaardigheid_achterkant as "rapporten.config.elements.zwemvaardigheid_achterkant" }